import { Link, NavLink, Outlet } from "react-router-dom";

import { useAuthSession } from "@/auth";
import { StatsHeader } from "@/components/StatsHeader";
import { env } from "@/env";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  isActive
    ? "text-sm font-medium text-slate-900 underline underline-offset-4"
    : "text-sm text-slate-500 hover:text-slate-900";

export function Layout(): JSX.Element {
  const { user, signOut } = useAuthSession();

  return (
    <div className="min-h-full flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <Link to="/chains" className="text-lg font-semibold text-slate-900">
              truck-tour-finder
            </Link>
            <span className="text-xs uppercase tracking-wide px-2 py-0.5 rounded bg-slate-100 text-slate-600">
              {env.profile}
            </span>
            {/* Top-level nav. The 3D viewer is a sibling page to the
                chain list rather than nested under it — `react-router`
                NavLink handles the active-link styling. */}
            <nav className="flex items-center gap-4">
              <NavLink to="/chains" end className={navLinkClass}>
                Chains
              </NavLink>
              <NavLink to="/chains/graph-3d" className={navLinkClass}>
                Network 3D
              </NavLink>
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <StatsHeader />
            {user && (
              <div className="flex items-center gap-3 text-sm">
                <span className="text-slate-700">{user.name || user.email}</span>
                <button
                  type="button"
                  onClick={signOut}
                  className="text-slate-500 hover:text-slate-900 underline-offset-2 hover:underline"
                >
                  sign out
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </main>
    </div>
  );
}
